import React, { useMemo } from 'react';
import { createIssuesUrl, toQuotedString } from '@atlassian/jira-common-jql/src/helpers';
import { defineMessages, useIntl } from '@atlassian/jira-intl';
import { SubtleText } from '../styled';

type Props = {
	projectKey: string;
	componentName: string;
	issueCount: number;
};

const messages = defineMessages({
	noIssues: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.no-issues',
		defaultMessage: 'No issues',
		description: 'Displayed when a component has no issues linked to it.',
	},
	issueCount: {
		id: 'project-pages-project-directories.components.view.compass-table.cell.issue-count',
		defaultMessage: '{issueCount, plural, one {# issue} other {# issues}}',
		description: 'Displayed when a component has some issues linked to it.',
	},
});

export default function IssuesCell(props: Props) {
	const { projectKey, componentName, issueCount } = props;
	const { formatMessage } = useIntl();

	const issuesUrl = useMemo(() => {
		const jql = `project = ${toQuotedString(projectKey)} AND component = ${toQuotedString(
			componentName,
		)}`;

		return createIssuesUrl(jql);
	}, [projectKey, componentName]);

	return issueCount > 0 ? (
		<a
			data-testid="project-directories.components.compass-table.cells.issues.link"
			href={issuesUrl}
			target="_blank"
			rel="noopener noreferrer"
		>
			{formatMessage(messages.issueCount, {
				issueCount,
			})}
		</a>
	) : (
		<SubtleText>{formatMessage(messages.noIssues)}</SubtleText>
	);
}
